import React from "react";
import { CHECKLIST_DUOTONE_ICONS } from "../../../utils/svgs_duotone";
import { AppCard, AppCardContent } from "../../Generic/AppCard";
import { AppIcon } from "../../Generic/AppIcon";
import { AppListItem } from "../../Generic/AppList";
import NextButton from "../../NextButton/NextButton";

interface Props {
  title: string;
  onClick: () => void;
}

const ListOfVisitsCard = (props: Props) => {
  return (
    <AppCard className="ListOfVisitsCard" onClick={props.onClick}>
      <AppCardContent>
        <AppListItem
          leading={<AppIcon icon={CHECKLIST_DUOTONE_ICONS} />}
          title={props.title}
          trailing={<NextButton />}
        />
      </AppCardContent>
    </AppCard>
  );
};

export default ListOfVisitsCard;
